
































































import { Component, Prop, Vue } from 'vue-property-decorator';
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';

@Component({
  components: {
    Navbar,
    Footer,
  },
})
export default class ComoFunciona extends Vue {
  public data() {
    return {
      title: 'Aquí te explicamos cómo funciona',
      subtitle: 'Con el tratamiento de alineadores invisibles Toothly ponemos a tu alcance la sonrisa de tus sueños en 3 sencillos pasos, de forma segura, discreta y sin necesidad de ir al dentista.',
      cta: '¡Quiero mi kit!',
      steps: [
        { image: null, number: 'Paso #1', title: 'Primera impresión',
          description: 'Con tu ayuda y la de nuestro kit de impresiones dentales, hacemos una reconstrucción 3D de tus dientes para determinar cuál será la mejor manera de alinearlos. Tu plan de tratamiento será evaluado por nuestro grupo de ortodoncistas certificados y especializados para asegurar que obtengas el mejor resultado en un periodo de 6 meses.', cta: 'Quiero mi kit', img: 'step-1'},
        { image: null, number: 'Paso #2', title: 'Cargando sonrisa',
          description: 'Una vez que hayamos terminado de evaluar tu tratamiento Toothly, te enviaremos una vista previa para que puedas ver cómo nuestros alineadores irán cambiando la posición de tus dientes a lo largo de tu tratamiento hasta lograr la sonrisa perfecta. Después haremos llegar hasta la puerta de tu casa tus alineadores Toothly junto con un kit premium de blanqueamiento.', cta: 'Quiero mi kit', img: 'step-2' },
        { image: null, number: 'Paso #3', title: '¡No dejes de sonreír!',
          description: 'Al terminar tu tratamiento, ponemos a tu disposición un set de retenedores dentales para ayudarte a mantener tu nueva sonrisa. Úsalos durante la noche para evitar que tus dientes vuelvan a su posición inicial.', cta: 'Conoce nuestros productos', img: 'step-3' },
      ],
    };
  }
}
